import { SocialType } from "types";

export const socials: SocialType[] = [
  {
    name: "Twitter",
    url: "https://www.twitter.com/kryptocentrum",
  },
];
